import { Observable } from 'rxjs';
import { InvoicesCreditOverviewRequest, InvoicesCreditOverviewResponse } from '../../model/invoices-credits.model';

export abstract class InvoiceCreditOverviewAdapter {
  abstract loadInvoiceOverview(
    invoiceRequest: InvoicesCreditOverviewRequest
  ): Observable<InvoicesCreditOverviewResponse>;
}
